import { Box, ButtonProps, CircularProgress, Stack } from "@mui/material";
import { Button as MUIButton } from "@mui/material";
import { FC } from "react";

const Button: FC<ButtonProps & { loading?: boolean }> = ({
  loading = false,
  children,
  ...props
}) => {
  if (!loading) return <MUIButton {...props}>{children}</MUIButton>;
  return (
    <MUIButton {...props}>
      <Stack spacing={2} direction="row" alignItems="center">
        <Box component="span">{children}</Box>
        <CircularProgress size={16} />
      </Stack>
    </MUIButton>
  );
};

export default Button;
